"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = __importStar(require("prop-types"));
exports.configurationPropTypes = PropTypes.shape({
    client_id: PropTypes.string.isRequired,
    redirect_uri: PropTypes.string.isRequired,
    response_type: PropTypes.string.isRequired,
    scope: PropTypes.string.isRequired,
    authority: PropTypes.string.isRequired,
    silent_redirect_uri: PropTypes.string.isRequired,
    automaticSilentRenew: PropTypes.bool,
    loadUserInfo: PropTypes.bool,
    triggerAuthFlow: PropTypes.bool,
    storeJwtInMemory: PropTypes.bool,
    metadata: PropTypes.shape({
        issuer: PropTypes.string,
        jwks_uri: PropTypes.string,
        authorization_endpoint: PropTypes.string,
        token_endpoint: PropTypes.string,
        userinfo_endpoint: PropTypes.string,
        end_session_endpoint: PropTypes.string,
        revocation_endpoint: PropTypes.string,
        introspection_endpoint: PropTypes.string,
    }),
}).isRequired;
exports.configurationDefaultProps = {
    automaticSilentRenew: true,
    loadUserInfo: true,
    triggerAuthFlow: true,
    storeJwtInMemory: false,
};
